import React from 'react';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import ButtonRow from './ButtonRow';
import ErrorMessage from './ErrorMessage';
import GeneralSearchStrip from './GeneralSearchStrip';
import Loading from './loading';
import { saveAs } from 'file-saver';
import InvoiceExtensionTypeEnum from '../Enums/InvoiceExtensionTypeEnum';
import FigmaPopup from '../Elements/figmaPopup';
import PopupTypesEnum from '../Enums/PopupTypesEnum';

class InvoicePdfPreviewComponent extends React.Component {
  static defaultProps = {
    id: 0,
    attachRoleKey: '',
    excelWordRoleKey: '',
    downloadFileName: null,
    hideSearchStrip: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      invoice: '',
      loading: true,
      invoiceDescription: null,
      popup: null,
    };

    this.convertToExcelOnClick = this.convertToExcelOnClick.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  componentDidMount() {
    this.loadInvoice();
  }

  loadInvoice() {
    this.props.invoiceDescription
      .invoiceService({ id: this.props.id, extensionType: InvoiceExtensionTypeEnum.PDF, forIFrame: true })
      .then((result) => {
        this.setState({ invoice: result, loading: false });
      })
      .catch(() => ErrorMessage.SetErrorMessage('IIPV37'));
  }

  getByteArray(result) {
    const byteCharacters = atob(result);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return byteArray;
  }

  handleDownload(downloadType) {
    if (downloadType === 'Excel') {
      this.convertToExcelOnClick();
    } else if (downloadType === 'Word') {
      this.convertToWordOnClick();
    } else if (downloadType === 'Pdf') {
      this.convertToPdfOnClick();
    } else if (downloadType === 'Attach') {
      this.attachButtonOnclick();
    } else {
      this.setState({ loading: true });
      this.loadInvoice();
    }
  }

  attachFunction(id) {
    this.props.invoiceDescription
      .attachInvoiceServiceFunction(this.props.id)
      .then((response) => {
        if (!response.success) {
          ErrorMessage.SetErrorMessage('IIPV63');
          return;
        }
        response.success
          ? ErrorMessage.SetNotification(response.result)
          : ErrorMessage.SetNotification('Attached report to Invoice.');
      })
      .catch(() => ErrorMessage.SetErrorMessage('IIPV65'));
  }

  attachButtonOnclick(id) {
    this.setState({
      popup: (
        <FigmaPopup
          type={PopupTypesEnum.Approve}
          text='Adding this report as PDF attachment.'
          okPopupFunction={(reason) => {
            this.setState({ popup: null });
            this.attachFunction(id);
          }}
          closePopupFunction={() => this.setState({ popup: null })}
        />
      ),
    });
  }

  convertToWordOnClick() {
    const fileName =
      this.props.downloadFileName ??
      `${this.props.invoiceDescription.fileNamePrefix}_${this.props.id}_${dateTimeHelper.nowStr()}`;
    this.props.invoiceDescription
      .invoiceService({ id: this.props.id, extensionType: InvoiceExtensionTypeEnum.Word })
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        const byteArray = this.getByteArray(result);
        saveAs(
          new Blob([byteArray], {
            type: 'data:application/application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          }),
          fileName + '.docx'
        );
      })
      .catch(() => ErrorMessage.SetErrorMessage('IIPV69'));
  }

  convertToExcelOnClick() {
    const fileName =
      this.props.downloadFileName ??
      `${this.props.invoiceDescription.fileNamePrefix}_${this.props.id}_${dateTimeHelper.nowStr()}`;
    this.props.invoiceDescription
      .invoiceService({ id: this.props.id, extensionType: InvoiceExtensionTypeEnum.Excel })
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        const byteArray = this.getByteArray(result);
        saveAs(
          new Blob([byteArray], { type: 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          fileName + '.xlsx'
        );
      })
      .catch(() => ErrorMessage.SetErrorMessage('IIPV78'));
  }

  convertToPdfOnClick() {
    const fileName =
      this.props.downloadFileName ??
      `${this.props.invoiceDescription.fileNamePrefix}_${this.props.id}_${dateTimeHelper.nowStr()}`;
    this.props.invoiceDescription
      .invoiceService({ id: this.props.id, extensionType: InvoiceExtensionTypeEnum.PDF, forIFrame: false })
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        const byteArray = this.getByteArray(result);
        saveAs(new Blob([byteArray], { type: 'data:application/pdf' }), fileName + '.pdf');
      })
      .catch(() => ErrorMessage.SetErrorMessage('IIPV78'));
  }

  renderSearchStrip() {
    if (this.props.hideSearchStrip) return null;
    return (
      <GeneralSearchStrip
        isRefreshDisabled={false}
        clickOnRefresh={() => this.loadInvoice()}
      />
    );
  }

  renderButtonsAndPanels() {
    return (
      <ButtonRow
        colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Common, ButtonColorsEnum.Common, ButtonColorsEnum.Common]}
        labels={['Attach', '', '', '']}
        keys={['Attach', 'Pdf', 'Excel', 'Word']}
        icons={['fa-solid fa-paperclip', 'fa-solid fa-file-pdf', 'fa-solid fa-file-excel', 'fa-solid fa-file-word']}
        roleKeys={[this.props.attachRoleKey, null, this.props.excelWordRoleKey, this.props.excelWordRoleKey]}
        buttonTypes={[
          ButtonTypeEnum.NormalIconLeft,
          ButtonTypeEnum.NormalIconOnly,
          ButtonTypeEnum.NormalIconOnly,
          ButtonTypeEnum.NormalIconOnly,
        ]}
        iconPositions={[
          IconPositionEnum.Left,
          IconPositionEnum.Center,
          IconPositionEnum.Center,
          IconPositionEnum.Center,
        ]}
        onClick={this.handleDownload}
      />
    );
  }

  render() {
    return this.state.loading ? (
      <Loading />
    ) : (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        {this.renderSearchStrip()}
        <div
          elevation={6}
          className='border p-1 m-1'
          style={{ minWidth: '800px', height: '800px' }}
        >
          <div style={{ width: '100%', height: '95%' }}>
            <iframe
              src={`data:application/pdf;base64,${this.state.invoice}`}
              style={{ width: '100%', height: '100%' }}
              title='invoiceFrame'
            ></iframe>
          </div>
        </div>
        {this.state.popup}
      </div>
    );
  }
}

export default InvoicePdfPreviewComponent;
